<template>
  <div class="container" v-cloak>
    <div class="main-in">
      <div is='titlebox' :nav='JSON.parse(nav)'></div>
      <div class="content">
        <div class="min-h">
          <div class="btns f-row-c">
            <div class="btn f-row-c pinter" :class="act==0?'actBtn':''" @click="onTab(0)">文件资料</div>
            <div class="btn f-row-c pinter" :class="act==1?'actBtn':''" @click="onTab(1)">学习资料</div>
          </div>
          <div class="file_info_box">
            <div class="searchbox">
              <div class="search_about pb-1">
                <div class="mb-2 pb-1">
                  <el-input suffix-icon='el-icon-search' v-model="inputValue" @change="getList" placeholder="请输入内容"></el-input>
                </div>

                <div class="mb-2 font-1" v-for="(items,key,indexs) in searchInfoList" :key='indexs'>
                  <div class="f-row-l" v-if='key'>
                    {{ searchInfoList[key].label || '' }}：
                    <div class="pr-1 pinter" :class="searchInfoList[key].act==index?'act':''"
                         v-for="(item,index) in searchInfoList[key].list" :key='index' @click="onSearchType(key,index)">
                      {{ item.text || '' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- {{JSON.stringify(list)}} -->
            <div v-if='infoTip'>
              <div class="mt-1" v-if="items.msgList.length>0" v-for="(items,indexs) in list" :key='indexs'>
                <div class="bb-1 f-row-b ">
                  <span class="bbact pr-1">{{ items.itemText || '' }}</span>
                  <div class="font-2 pinter color-red" @click="$util.goPage('news', items.type,items.itemValue)">更多&gt;</div>
                </div>
                <div class="">
                  <div v-for="(item,ind) in items.msgList" :key="ind" class="f-row-b wrap mt-1 pinter act-h"
                      @click="$util.goPage('newDetail', items.type, item.id)">
                    <div class="overf-elli w-90" :title="item.title">
                      <div class="triangle"></div>
                      {{ item.title || '' }}
                    </div>
                    <div class="color-gray time">{{ item.putTime.split(' ')['0'] || '' }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="f-row-c mt-2 mb-2 h-200">
              暂无数据
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  computed: {

    nav: function () {
      var label = this.$util.getTitle(this.type)
      if (label.indexOf('》') != -1) {
        var str = this.$util.getTitle(this.type)
        label = str.split('》')[1]
      }
      var arr = [
        {
          label: label,
          path: '/fileInfo',
          type: this.$route.query.type
        }
      ]
      return JSON.stringify(arr)
    }
  },
  name: 'FileInfoList',
  components: {},
  data: function () {
    return {
      type: this.$route.query.type,
      act: 0,
      // todo 日期筛选标识
      dateFlag: '',
      // todo 输入框标识
      inputFlag: '',
      // todo 输入框内容
      inputValue: '',
      // todo 信息类型
      msgType: '',
      searchVal: '',
      searchInfoList: {
        location: {
          label: '搜索位置',//位置
          act: 0,
          list: [
            {text: '全部', value: ''},
            {text: '标题', value: '0'},
            {text: '正文', value: '1'},
          ],
        },
        time: {
          label: '日期筛选',//时间
          act: 0,
          list: [
            {text: '全部', value: ''},
            {text: '一周内', value: 'bz'},
            {text: '一月内', value: 'by'},
            {text: '半年内', value: 'bn'},
            {text: '一年内', value: 'yn'}
          ],
        },
        scope: {
          label: '查询范围',//范围
          act: 0,
          list: [],
        }
      },
      info: [],
      openInfo: [],
      youthCentre: [],
      list: [],
      infoTip:true,
    };
  },

  created() {
    this.init();
  },

  methods: {
    onSearchType(key, index) {
      this.$set(this.searchInfoList[key], 'act', index)
      // console.log(key, index)
      if (key == 'time') this.dateFlag = this.searchInfoList[key].list[index].value
      if (key == 'location') this.inputFlag = this.searchInfoList[key].list[index].value
      if (key == 'scope') this.msgType = this.searchInfoList[key].list[index].value
      this.getList()
    },
    onTab(act) {
      if (this.act != act) {
        this.act = act;
        this.getListFn()
        for (var key in this.searchInfoList) {
          this.$set(this.searchInfoList[key], 'act', 0)
        }
      }
      this.init()
    },
    getListFn() {
      var arr = []
      if (this.act == 0) {
        arr = [
          {text: '所有分类', value: '',type:''},
          {text: '青团函', value: '26',type:36},
          {text: '青团发', value: '27',type:37},
          {text: '青团', value: '28',type:38},
          {text: '青团联发', value: '29',type:39},
          {text: '青团办', value: '30',type:40},
          {text: '青团办通报', value: '31',type:41},
          {text: '青团办内通', value: '32',type:42},
          {text: '其他', value: '33',type:43},
        ]

      } else {
        arr = [
          {text: '所有分类', value: '',type:44},
          {text: '讲话', value: '34',type:44},
          {text: '新思想', value: '35',type:45},
          {text: '理论', value: '36',type:46},
          {text: '重要论述', value: '37',type:47},
          {text: '团史百科', value: '38',type:48}
        ]
      }

      this.$set(this.searchInfoList.scope, 'list', arr)
    },
    getList() {
      var params = {
        dateFlag: this.dateFlag,
        flag: this.act.toString(),
        inputFlag: this.inputFlag,
        inputValue: this.inputValue,
        msgType: this.msgType
      }
      for (var paramsKey in params) {
        if(!params[paramsKey]) {
          delete params[paramsKey]
        }
      }
      this.$get('/web/information/fileList', params).then(res => {
        if (res.success) {
          this.list=[]
          var arr = res.result;
          var sum=0
          arr.forEach(k=>{ 
            k.type=Number(k.itemValue)+10
            this.list.push(k)
            if(!(k.msgList&&k.msgList.length>0)){ 
              sum+=1;
            }
          })

          if(sum==this.list.length){ 
            this.infoTip=false
          }else{
            this.infoTip=true
          }
        }
      })
    },
    init() {
      // this.getInfo();
      // this.getOpenInfo();
      // this.getYouthCentre()
      this.getListFn()
      this.getList()
    },
    getInfo() {//文件资料
      var param = {
        pageNo: 1,
        pageSize: 6,
        // msgType:13
        msgType: 20
      }
      this.$get('/web/information/list', param).then(res => {
        this.info = res.result.records;
      })
    },
    getOpenInfo() {//预决算公开
      var param = {
        pageNo: 1,
        pageSize: 6,
        msgType: 16
      }
      this.$get('/web/information/list', param).then(res => {
        this.openInfo = res.result.records;
      })
    },
    getYouthCentre() {//青海青少年研究youthCentre
      var param = {
        pageNo: 1,
        pageSize: 6,
        msgType: 18
      }
      this.$get('/web/information/list', param).then(res => {
        this.youthCentre = res.result.records;
      })
    },
  },


};
</script>

<style scoped="scoped" lang="scss">
.btns {
  width: 316px;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 19px;

  .btn, .actBtn {
    width: 50%;
    height: 44px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }

  .btn {
    background: #D9D9D9;
    color: #333333;
  }

  .actBtn {
    background: #A62725;
    color: #ffffff;
  }
}

.file_info_box {
  width: 1100px;
  margin: auto;
  color: #333333;

  .searchbox {
    height: 241px;
    background: #F7F7F7;
    margin: auto;

    .search_about {
      width: 790px;
      margin: auto;
      padding-top: 36px;
    }
  }
}

.act {
  color: #A62725;
}
.h-200{
    height: 200px;
    color: #666666;
}
.color-gray {
  color: #999999;
}

.act-h:hover {
  color: #BA0711;

  .color-gray {
    color: #BA0711;
  }
}
</style>
